import React from 'react';
import {IQuote} from "../../../../../../../../app/interfaces/quote/IQuote";
import {useTranslation} from "react-i18next";

type QuoteClientProps = {
    quote: IQuote;
}

const QuoteClient: React.FC<QuoteClientProps> = ({
                                                     quote
                                                 }) => {
    const {t} = useTranslation();

    if (quote.client === null || quote.client === '') {
        return (
            <div className={'details-box-item-field-value'}>
                {" "}
            </div>
        );
    }

    return (
        <div className={'details-box-item-field-value'}>
            {quote.client}
        </div>
    );
};

export default QuoteClient;
